export const StorylyCategory = Object.freeze({
    BASICS: "BASICS",
    BENEFITS: "BENEFITS",
    DASHBOARD: "DASHBOARD",
    FEATURED_RECRUIT: "FEATURED_RECRUIT",
    FEATURED_RECRUITER: "FEATURED_RECRUITER",
    PREPARE: "PREPARE",
    SUPPORT_SQUAD: "SUPPORT_SQUAD",
});
